import { ref } from 'vue';
import { defineStore } from 'pinia';
import { TUserRole } from '@/modules/acl/aclService';
import { SWITCHABLE_TARGET_ROLES, VIEW_AS_QUERY_KEY } from '@/modules/acl/viewAsRole';

const readViewAsFromUrl = (): TUserRole | null => {
  const params = new URLSearchParams(window.location.search);
  const value = params.get(VIEW_AS_QUERY_KEY);

  if (value && (SWITCHABLE_TARGET_ROLES as readonly string[]).includes(value)) {
    return value as TUserRole;
  }

  return null;
};

const useViewAsStore = defineStore('viewAs', () => {
  const viewAsRole = ref<TUserRole | null>(readViewAsFromUrl());

  const setViewAsRole = (role: TUserRole | null): void => {
    viewAsRole.value = role;

    // Keep the URL in sync without triggering a router navigation.
    // Using replaceState avoids the circular-import that would arise from
    // importing router.ts here (router.ts already imports this store).
    const url = new URL(window.location.href);

    if (role) {
      url.searchParams.set(VIEW_AS_QUERY_KEY, role);
    } else {
      url.searchParams.delete(VIEW_AS_QUERY_KEY);
    }

    window.history.replaceState(window.history.state, '', url.toString());
  };

  return { viewAsRole, setViewAsRole };
});

export default useViewAsStore;
